import React from 'react';
import { useAppSelector } from 'src/store';

import { Helmet } from 'react-helmet-async';
import { translate } from 'src/i18n/tHelper';
import BaseComponent from 'src/core/base.component';
import { Button, Grid } from 'src/components';

import Alert from 'src/components/Alert';
import AlertTitle from 'src/components/AlertTitle';
import RaporlamaRaporGruplariListe from '../RaporGruplari/Liste';
import RaporlamaRaporGruplariEkle from '../RaporGruplari/Ekle';
import PersonelListe from '../../../servisPersonelYetki/personelListe';
import Card from 'src/components/Card';
import CardHeader from 'src/components/CardHeader';
import CardContent from 'src/components/CardContent';
import { useNavigate } from 'react-router';
import PersonelList from './PersonelList';
import RaporTipPersonelListesi from './RaporTipPersonelListesi';

interface RaporlamaRaporGruplariProps { };

const RaporPeronel = (props: RaporlamaRaporGruplariProps): JSX.Element => {
    const state = useAppSelector(s => s.raporlamaTanim);
    const navigate = useNavigate();

    const backHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        navigate("..");
    };
    return (
        <>
            <BaseComponent>
                <Card variant="outlined">
                    <CardHeader title={translate("pages|raporlama", "Rapor Personelleri")} />
                    <CardContent>
                        <Grid container>
                            <Grid item md={1}>
                                <Button customType="back" onClick={backHandler} />
                            </Grid>
                            <Grid item>
                                {!state.activeRow?.id && (
                                    <Alert severity="warning" >
                                        <AlertTitle>{translate("pages|raporlama", "Bilgilendirme")}</AlertTitle>
                                        {`* ${translate("pages|raporlama", "Sayfada yenileme yaptığınız için arka plandaki alt kayıt kayboldu. Geri dönüp kaydın tekrar detayına gidin.")}`}
                                    </Alert>
                                )}
                            </Grid>
                        </Grid>
                        <Card variant="outlined">
                            <CardHeader title={translate("pages|raporlama", "Personeller")} />
                            <CardContent>
                                <Grid container>
                                    {state.activeRow?.id > 0 && (
                                        <Grid item >
                                            <PersonelList />
                                        </Grid>
                                    )}
                                </Grid>
                            </CardContent>
                        </Card>
                        <Card variant="outlined">
                            <CardHeader title={translate("pages|raporlama", "Rapor Personelleri")} />
                            <CardContent>
                                <Grid container>
                                    {state.activeRow?.id > 0 && (
                                        <Grid item >
                                            <RaporTipPersonelListesi />
                                        </Grid>
                                    )}
                                </Grid>
                            </CardContent>
                        </Card>
                    </CardContent>
                </Card>
            </BaseComponent >
        </>
    )
};

export default RaporPeronel;